<h3 mat-dialog-title>Edit Domain - {{ssoDomain.ssoDomainValue}}</h3>
<form [formGroup]="editDomainForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>Domain</mat-label>
      <input matInput formControlName="domain">
      @if (editDomainForm.get('domain')?.errors?.['required']) {
        <mat-error>Domain is required.</mat-error>
      }
      @if (editDomainForm.get('domain')?.errors?.['pattern']) {
        <mat-error>Domain must be a valid URL.</mat-error>
      }
      @if (editDomainForm.get('domain')?.errors?.['blockedDomain']) {
        <mat-error>This domain is not allowed.</mat-error>
      }
    </mat-form-field>
    
    @if (errorMessage) {
      <div class="error-message">{{ errorMessage }}</div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" [disabled]="isSubmitting" (click)="onCancel()">Cancel</button>
    <button mat-flat-button 
            color="primary" 
            type="submit" 
            [disabled]="!editDomainForm.valid || isSubmitting">
      @if (loadingService.loading$ | async) {
        <app-loading-spinner [diameter]="20" [strokeWidth]="2"></app-loading-spinner>
      } @else {
        Edit
      }
    </button>
  </mat-dialog-actions>
</form>